import type { Translations } from '@/i18n/types';

type TFn = (key: keyof Translations) => string;

/** Editor tab identifiers */
export type EditorTab =
  | 'races'
  | 'tracks'
  | 'categories'
  | 'drivers'
  | 'profiles'
  | 'users'
  | 'bugs'
  | 'monitoring'
  | 'settings'
  | 'login';

/** All valid tabs for routing */
export const ALL_EDITOR_TABS: EditorTab[] = [
  'races',
  'tracks',
  'categories',
  'drivers',
  'profiles',
  'users',
  'bugs',
  'monitoring',
  'settings',
];

/** Tabs rendered in the main nav bar (excludes right-aligned items like settings) */
export const EDITOR_TABS: EditorTab[] = [
  'races',
  'tracks',
  'categories',
  'drivers',
  'profiles',
  'users',
  'bugs',
  'monitoring',
];

const TAB_KEYS: Record<Exclude<EditorTab, 'login'>, keyof Translations> = {
  races: 'tab.races',
  tracks: 'tab.tracks',
  categories: 'tab.categories',
  drivers: 'tab.drivers',
  profiles: 'tab.profiles',
  users: 'tab.users',
  bugs: 'tab.bugs',
  monitoring: 'tab.monitoring',
  settings: 'tab.settings',
};

export function getTabLabel(tab: Exclude<EditorTab, 'login'>, t: TFn): string {
  return t(TAB_KEYS[tab]);
}
